/* Benefits field guide: folds the chapters into an accordion (one open at a time), highlights the
   marker of the open chapter and pushes the photo in on it. Tapping a marker opens its chapter.
   Phones start with every chapter closed; from 990px the first is open. Content is complete
   without this script: every chapter stays open.
   The scroll correction sets <html data-roots-scroll-lock-until>, which assets/header.js honours,
   so the correction does not read as an upward scroll that reveals the sticky header. */
(function () {
  var ZOOM = '1.4';

  function init(root) {
    if (root.dataset.rgyInit === '1') return;
    root.dataset.rgyInit = '1';
    var zoom = root.querySelector('[data-rgy-zoom]');
    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-rgy-chapter]'));
    var markers = Array.prototype.slice.call(root.querySelectorAll('[data-rgy-marker]'));
    var toggles = chapters.map(function (c) { return c.querySelector('[data-rgy-toggle]'); });
    if (!zoom || !chapters.length || toggles.some(function (t) { return !t; })) return;
    var wide = window.matchMedia('(min-width: 990px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function open(chapter) {
      chapters.forEach(function (c, i) {
        var on = c === chapter;
        c.classList.toggle('is-open', on);
        toggles[i].setAttribute('aria-expanded', on ? 'true' : 'false');
        if (markers[i]) markers[i].classList.toggle('is-active', on);
      });
      if (chapter && !reduce.matches) {
        zoom.style.setProperty('--rgy-ox', chapter.style.getPropertyValue('--rgy-x'));
        zoom.style.setProperty('--rgy-oy', chapter.style.getPropertyValue('--rgy-y'));
        zoom.style.setProperty('--rgy-z', ZOOM);
      } else {
        zoom.style.setProperty('--rgy-z', '1');
      }
    }

    function toggle(chapter) {
      root.classList.add('is-interacted');
      // Closing a chapter above the tapped one would pull it up the screen; keep its head under
      // the finger instead.
      var before = chapter.getBoundingClientRect().top;
      open(chapter.classList.contains('is-open') ? null : chapter);
      var shift = chapter.getBoundingClientRect().top - before;
      if (shift) {
        document.documentElement.dataset.rootsScrollLockUntil = String(performance.now() + 300);
        // From 990px the PDP scrolls .page-wrapper, not the window. 'instant': base.css sets
        // scroll-behavior: smooth, which would animate this correction and show the page lurching.
        var scroller = (wide.matches && document.querySelector('.page-wrapper')) || window;
        scroller.scrollBy({ top: shift, behavior: 'instant' });
      }
    }

    function hashChapter() {
      var id = window.location.hash.slice(1);
      return chapters.filter(function (c) { return c.id === id; })[0] || null;
    }

    toggles.forEach(function (t, i) {
      t.hidden = false;
      t.addEventListener('click', function () { toggle(chapters[i]); });
    });
    // The markers are aria-hidden pointer shortcuts; the chapter toggles are the real controls.
    markers.forEach(function (m, i) {
      if (chapters[i]) m.addEventListener('click', function () { toggle(chapters[i]); });
    });
    window.addEventListener('hashchange', function () {
      var c = hashChapter();
      if (c) { open(c); c.scrollIntoView(); }
    });
    root.addEventListener('shopify:block:select', function (e) {
      var c = e.target.closest && e.target.closest('[data-rgy-chapter]');
      if (c) open(c);
    });

    root.classList.add('is-accordion');
    open(hashChapter() || (wide.matches ? chapters[0] : null));
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rgy-root]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
